var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFilterSearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_373_726",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 31
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.599854,
    width: 29.4667,
    height: 29.4667,
    fill: "url(#pattern0)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_373_726)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -2.59961,
    y: -2.86681,
    width: 35.5333,
    height: 35.5333,
    fill: "#0078CF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_373_726",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_373_726",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAAB70lEQVR4nO2cMU4DMRBFtwIOwbVSp4lft3AM4GSQDu6QwAGgN7JEgRAgSGbj+dZ/ktvovdEkC1t4mowxxhhjjDFmdFar1RlwBzwD9Z9nX0q5bZ8xqk8YTeyAoPr5tM8Y1SeMAzenfgl7GdUnjPZ1CwjbjeozZfqqAjej+oTRHhwfcfssD8OSyMcYY4wxRoAj3yfU6D+tsvlMyf4pqFHvGbL5hBG8OfXY9wzZfMJYKoqPo+4TRrYwkvmEkS2MZD5hZAsjmU8Y2cJI5hNGtjCS+YSRLYxkPmFkCyOZTxjZwkjmczDr9fqilHJdStkCb0uHke+05gfgap7n80WGvNlsLoGnBLE1wymlPLaZhG+yh8y3ww7d7PZz0XuDyHvmyEFvEwTVpOc+ctCvCYJqxtNmEzbo3jEkPx40HnTtvYXeaPoPzj8d9B+qf6PxoOupNsUbjQc91KYg4ikfgIinfAAinvIBiHjKByDiKR+AiKd8ACKe8gGIeMoHIOIpH4CIp3wAIp7yAYh4ygcg4ikfgIinfAAinvIBiHjKByDiKR+AiKd8ACKexhhjjDEdWOjanBp9zY6KZ5drcwi8ZkfF80c6b0j96zU7Kp6LXgscGLBT95wUvpL8cr2wiudS1wKf9GFYBDyNMcYYY4wxxhhjpoF4B4VjZQsqzHTMAAAAAElFTkSuQmCC"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterSearch);
export default __webpack_public_path__ + "static/media/filterSearch.fc6993e8a6a603bb9b3d93ec4f250896.svg";
export { ForwardRef as ReactComponent };